import React from "react";
import { Navigate } from "react-router-dom";

import { useAppSelector } from '@/store/hooks';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isLoggedIn, me } = useAppSelector((state) => state.auth);

  // Check access conditions
  const hasAccess =
    (isLoggedIn &&
      me?.id &&
      me?.isSubscribed &&
      !me?.isCanceled) ||
    me?.isAdmin;

  return hasAccess ? (
    <>{children}</>
  ) : (
    <Navigate to="/billing" replace />
  );
};

export default ProtectedRoute;